module.exports = __webpack_public_path__ + "img/maison-4.2c608839.png";